import { useThemeStore } from "@/stores/theme";

export function playClickSound() {
    const themeStore = useThemeStore();

  const soundSrc = themeStore.themeIndex === 1
    ? "/audio/click.mp3"
    : "/audio/click2.mp3";

  const sound = new Audio(soundSrc);
  sound.play().catch(err => console.warn("Audio play failed:", err));
}
